import { create } from 'zustand';

export type Filters = Partial<{
  type: string;
  status: string;
}>;

export type PaginationControl = {
  page: number;
  limit: number;
  orderBy?: string;
  orderByDirection?: 'asc' | 'desc';
};

type State = {
  filters: Filters;
  paginationControl: PaginationControl;
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updatePaginationControl: (
    paginationControl: Partial<PaginationControl>,
  ) => void;
  clearState: () => void;
};

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 20,
  },
});

const store = create<State & Actions>(
  (set, get) => ({
    ...getInitialState(),
    updateFilters: (filters) => {
      const currentPagination = get().paginationControl;

      return set({
        filters,
        paginationControl: {
          ...currentPagination,
          page: 1,
        },
      });
    },
    updatePaginationControl: (newState) => {
      const currentState = get().paginationControl;

      if (newState?.orderBy) {
        newState.page = 1;
      }

      return set((state) => ({
        paginationControl: {
          ...currentState,
          ...newState,
        },
      }));
    },
    clearState: () => set(getInitialState()),
  }),
);

export const useScheduledDataImportsSearchParams = () => {
  return store();
};
